import React from 'react';

import StyledFixedBottomBar from '../../../LegacyProjectFixedBar/StyledFixedBottomBar';
import StyledA from './StyledA';

export type CampaignFixedBarProps = {
  campaignBarText: string;
  campaignLink: string;
  campaignLinkText: string;
};

const CampaignFixedBar: React.FC<CampaignFixedBarProps> = ({
  campaignBarText,
  campaignLink,
  campaignLinkText,
  ...rest
}) => {
  const url = `${process.env.NEXT_PUBLIC_CANONICAL_HOST}/${campaignLink}`;

  return (
    <StyledFixedBottomBar {...rest}>
      {campaignBarText}
      <StyledA
        href={url}
        passHref
      >
        {campaignLinkText}
      </StyledA>
    </StyledFixedBottomBar>
  );
};

export default CampaignFixedBar;
